/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    /** Represents the AudioSettingsComponent */
    AudioSettings = "audio-settings",
    Map = "map",
    Inventory = "inventory",
    ModalInventory = "modal-inventory",
};
